import EventViewer from './components/EventViewer';

export default {
	component: EventViewer
};